export function getSearchParam(param: string) {
    const search = window.location.search;
    const searchParams = new URLSearchParams(search);
    return searchParams.get(param);
}
